export const PublicationDetailResultsTemplateStyles = `
.coveo-result {
  border-bottom: 1px solid #7f8eb0;
  padding: 24px 0;
}

.lbs-result-list-wrapper .field {
  display: inline-flex;
  align-items: center;
}

.lbs-result-list-wrapper .field-label {
  font-weight: bold;
  margin-right: 2.5px;
}

.coveo-link {
  background-repeat: no-repeat;
  background-position: 0 100%;
  background-size: 100% 1px;
  padding-bottom: 4px;
  display: inline;
}

.coveo-link:hover {
  text-decoration: none;
  background-image: linear-gradient(90deg, #001e62, #001e62);
  background-image: linear-gradient(90deg, #001e62, #001e62);
}

.lbs-result-list-wrapper .h3 {
  display: inherit;
  color: #001e62;
  font-weight: 400;
  line-height: 1.26667;
  font-family: var(--lbs-heading-font-family), serif;
  font-size: 1.75rem;
  margin-bottom: 5px;
}

.lbs-result-list-wrapper .page-description {
  color: #001e62;
  line-height: 1.5;
  font-size: 1rem;
  margin-bottom: 10px;
  margin-top: 24px; 
  font-family: var(--lbs-base-font-family), sans-serif;
  font-weight: normal;
}

.lbs-result-list-wrapper .page-details {
  color: #001e62;
  line-height: 1.5;
  font-size: 1rem;
  margin-bottom: 10px;
  font-family: var(--lbs-base-font-family), sans-serif;
  font-weight: normal;
}

.coveo-year {
  color: #6e6259;
  font-size: 0.875rem;
  margin: 20px 0;
  font-family: var(--lbs-base-font-family), sans-serif;
  font-weight: normal;
}

.lbs-result-list-wrapper .tag a {
  padding: 5px 6px 2px;
  color: #001e62;
  border: 1px solid #d7d2cb;
  display: inline-block;
  font-size: 0.625rem;
  text-decoration: none;
  margin: 0 10px 10px 0;
  font-weight: 700;
}

.lbs-result-list-wrapper .tag a:hover, .lbs-result-list-wrapper .tag a:focus {
  background: #001e62;
  border: 1px solid #001e62;
  color: #fff;
}

`;
